// extracted by mini-css-extract-plugin
export default {"department_name":"portfolioTooltips_department_name__wZ323","square":"portfolioTooltips_square__ycUB4","td":"portfolioTooltips_td__V4a2O","row":"portfolioTooltips_row__WEWub"};